export default __webpack_public_path__ + "static/media/gray-sort.a5e88fe9.svg";